import { useLanguage } from "../contexts/LanguageContext";
import { Github, Linkedin, Twitter } from "lucide-react";

export default function Footer() {
  const { t } = useLanguage();

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer-section" className="relative border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 py-20 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16 mb-20">
          <div>
            <span className="font-outfit font-medium text-white text-xl tracking-tight block mb-4">wedowedo</span>
            <p className="text-sm text-neutral-500 font-manrope leading-relaxed max-w-xs">
              {t("footer.tagline")}
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#" data-testid="footer-linkedin" className="text-neutral-600 hover:text-[#00F0FF] transition-colors"><Linkedin className="w-5 h-5" /></a>
              <a href="#" data-testid="footer-twitter" className="text-neutral-600 hover:text-[#00F0FF] transition-colors"><Twitter className="w-5 h-5" /></a>
              <a href="#" data-testid="footer-github" className="text-neutral-600 hover:text-[#00F0FF] transition-colors"><Github className="w-5 h-5" /></a>
            </div>
          </div>

          <div>
            <span className="font-mono text-[10px] tracking-[0.2em] text-neutral-600 mb-4 block">{t("footer.services")?.toUpperCase()}</span>
            <ul className="space-y-2.5">
              {t("footer.serviceLinks")?.map?.((link, i) => (
                <li key={i}>
                  <button onClick={() => scrollTo("#services")} className="text-sm text-neutral-500 hover:text-white transition-colors font-manrope">
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <span className="font-mono text-[10px] tracking-[0.2em] text-neutral-600 mb-4 block">{t("footer.company")?.toUpperCase()}</span>
            <ul className="space-y-2.5">
              {t("footer.companyLinks")?.map?.((link, i) => {
                const hrefs = ["#", "#cases", "#process", "#contact"];
                return (
                  <li key={i}>
                    <button onClick={() => scrollTo(hrefs[i] || "#")} className="text-sm text-neutral-500 hover:text-white transition-colors font-manrope">
                      {link}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>

          <div>
            <span className="font-mono text-[10px] tracking-[0.2em] text-neutral-600 mb-4 block">{t("footer.legal")?.toUpperCase()}</span>
            <ul className="space-y-2.5">
              {t("footer.legalLinks")?.map?.((link, i) => (
                <li key={i}>
                  <button className="text-sm text-neutral-500 hover:text-white transition-colors font-manrope">
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="overflow-hidden mb-12">
          <span className="font-outfit font-bold text-[12vw] leading-none text-white/[0.03] tracking-tighter select-none block">
            wedowedo
          </span>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 border-t border-white/5">
          <p className="text-xs text-neutral-600 font-manrope">
            &copy; {new Date().getFullYear()} {t("footer.copyright")}
          </p>
          <p className="text-xs text-neutral-700 font-mono tracking-wider">
            {t("footer.address")}
          </p>
        </div>
      </div>
    </footer>
  );
}
